import { render, staticRenderFns } from "./EditStaff.vue?vue&type=template&id=a26424ec"
import script from "./EditStaff.vue?vue&type=script&lang=js"
export * from "./EditStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customers/EditStaff.vue
// module id = 2558
// module chunks = 31